import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-3 p-3" }
const _hoisted_2 = { class: "flex justify-between items-end space-x-3" }
const _hoisted_3 = { class: "ml-1 text-dark-muted text-sm" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "flex justify-end space-x-2" }

import { computed, reactive, ref } from 'vue';

import { CarModelResource } from '@shared/resources/car-model';
import { CarModelCreateUpdateDto } from '@shared/dto/car-model';
import { carModelCreateUpdateSchema } from '@shared/validation/car-model';

import { useValidator, ValidationKeyObserver } from '@/libs/validator';
import { useCarModelsStore } from '@/stores/dictionary/car-models';
import { useCarBrandsStore } from '@/stores/dictionary/car-brands';
import { BaseModal, useModalControls, useModalsStore } from '@components/modals';
import SingleLine from '@ui-kit/inputs/single-line/SingleLine.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import Label from '@ui-kit/label/Label.vue';
import { SingleSelect, useSelectClientDataManager } from '@ui-kit/inputs/select';
import { CarBrandResource } from '@shared/resources/car-brand';
import ModalManageCarBrand from '../../car-brands/modals/ModalManageCarBrand.vue';

interface Emits {
  (e: 'save', value: CarModelResource): void;
}
interface Props {
  data?: CarModelResource;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalManageCarModel',
  props: {
    data: null
  },
  emits: ["save"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'save', value: CarModelResource): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  data?: CarModelResource;
}

const carModelsStore = useCarModelsStore();
const carBrandsStore = useCarBrandsStore();
const modalsStore = useModalsStore();
const { close } = useModalControls();





const formData = ref<Partial<CarModelCreateUpdateDto>>({
  name: props.data?.name || '',
  car_brand_id: props.data?.car_brand.id || undefined,
});
const validator = useValidator({
  data: formData,
  schema: computed(() => carModelCreateUpdateSchema),
});

const selectedBrand = computed<CarBrandResource | undefined>(() => {
  return formData.value.car_brand_id
      ? carBrandsStore.data.find((carBrand) => carBrand.id === formData.value.car_brand_id)
      : undefined;
});
function chooseBrand(brand: CarBrandResource) {
  formData.value.car_brand_id = brand.id;
}
const brandsSelectManager = useSelectClientDataManager({
  selected: selectedBrand,
  data: computed(() => carBrandsStore.data),
  hideSelected: true,
  searchBy: ['name', 'country'],
});

function save() {
  if (validator.validate()) {
    let promise: Promise<CarModelResource>;
    if (props.data?.id) {
      promise = carModelsStore.update(props.data.id, formData.value as CarModelCreateUpdateDto, validator);
    } else {
      promise = carModelsStore.add(formData.value as CarModelCreateUpdateDto, validator);
    }
    promise.then((resource) => {
      emit('save', resource);
      close();
    });
  }
}
function addCarBrand() {
  modalsStore.addModal({
    component: ModalManageCarBrand,
    events: {
      save(brand: CarBrandResource) {
        formData.value.car_brand_id = brand.id;
      },
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseModal), {
    title: __props.data?.id ? _ctx.$t('pages.car-models.edit-label') : _ctx.$t('pages.car-models.create-label'),
    "no-body-padding": "",
    size: "lg"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ValidationKeyObserver), { keys: "name" }, {
          default: _withCtx(({ firstErrorMessage }) => [
            _createVNode(Label, {
              label: _ctx.$t('fields.name'),
              required: ""
            }, {
              default: _withCtx(({ id }) => [
                _createVNode(SingleLine, {
                  id: id,
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  errors: firstErrorMessage
                }, null, 8, ["id", "modelValue", "errors"])
              ]),
              _: 2
            }, 1032, ["label"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Label, {
            label: _ctx.$t('fields.car_brand'),
            class: "flex-grow",
            required: ""
          }, {
            default: _withCtx(({ id }) => [
              _createVNode(_unref(ValidationKeyObserver), { keys: "car_brand_id" }, {
                default: _withCtx(({ firstErrorMessage }) => [
                  _createVNode(_unref(SingleSelect), {
                    "data-manager": _unref(brandsSelectManager),
                    "model-value": _unref(selectedBrand),
                    "onUpdate:modelValue": chooseBrand,
                    "hide-empty": "",
                    "select-option-text": _ctx.$t('pages.car-models.select-brand'),
                    errors: firstErrorMessage
                  }, {
                    option: _withCtx(({option}) => [
                      _createTextVNode(_toDisplayString(option.name) + " ", 1),
                      _createElementVNode("span", _hoisted_3, "(" + _toDisplayString(option.country) + ")", 1)
                    ]),
                    _: 2
                  }, 1032, ["data-manager", "model-value", "select-option-text", "errors"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(Button, {
            class: "w-32",
            size: "xl",
            "button-type": "outline",
            onClick: addCarBrand
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.new')), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(Button, {
            onClick: _unref(close),
            "button-type": "outline",
            disabled: _unref(carModelsStore).isLoad
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(Button, {
            onClick: save,
            loading: _unref(carModelsStore).isLoad
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.save')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})